import { useMe } from "src/context/MeContext";

export function useFeatureFlag(flagName: string): boolean {
  const me = useMe();
  return me.organization?.enabledFeatureFlags?.includes(flagName) ?? false;
}
